export default __webpack_public_path__ + "static/media/welfare-legal.a3e068a0.png";